import React, { useState } from "react";
import { Paper, Box, Typography, Stack } from "@mui/material";
import PropTypes from "prop-types";
import { useNavigate, useParams } from "react-router-dom";

import { getRuta } from "../../../helpers/Helpers";
import BackButton from "../../../components/ui/BackButton";
import SegmentedTabs from "../../../components/ui/SegmentedTabs";
import ClientDetails from "./ClientDetails";
import ClientReferences from "./ClientReferences";
import ClientCredits from "./ClientCredits";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ padding: "22px" }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

// Detalle de cliente — mismo patron de cabecera que el handoff usa en
// "Detalle de credito": boton Regresar + titulo/subtitulo, y pestañas
// segmentadas en lugar de los Tabs con icono del diseño anterior.
export const DetalleClientContainer = () => {
  let ruta = getRuta();
  let navigate = useNavigate();
  const { id } = useParams();
  const [value, setValue] = useState(0);
  const [clientName, setClientName] = useState("");

  return (
    <div>
      <Paper sx={{ overflow: "hidden" }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "stretch", sm: "center" }}
          justifyContent="space-between"
          spacing={2}
          flexWrap="wrap"
          sx={{ padding: "18px 22px", borderBottom: "1px solid", borderColor: "divider" }}
        >
          <Stack direction="row" alignItems="center" spacing={2} sx={{ minWidth: 0 }}>
            <BackButton onClick={() => navigate(`${ruta}/clients`)} />
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 600,
                  fontSize: 16.5,
                  color: "text.primary",
                  lineHeight: 1.1,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {clientName}
              </Typography>
              <Typography sx={{ fontSize: 13, color: "text.disabled", marginTop: "3px" }}>
                Detalle del cliente
              </Typography>
            </Box>
          </Stack>

          <SegmentedTabs
            tabs={[{ label: "Cliente" }, { label: "Referencias" }, { label: "Créditos" }]}
            value={value}
            onChange={setValue}
          />
        </Stack>

        <TabPanel value={value} index={0}>
          <ClientDetails id={id} setClientName={setClientName} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ClientReferences id={id} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <ClientCredits id={id} />
        </TabPanel>
      </Paper>
    </div>
  );
};
